// lib files
;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:dotorg-next":true});}catch(e){}}();import {
  ACCESSIBILITY_FILTER,
  ACCESSIBILITY_VALUES,
  DURATION_FILTER,
  DURATION_VALUES,
  PASSPORT_STATUS_FILTER,
  PASSPORT_STATUS_VALUES,
  RESULT_TYPE_FILTER,
  RESULT_TYPE_VALUES,
  SEARCH_FIELDS,
  SORT_OPTION,
  SORT_VALUES
} from '@/lib/types/search/searchFilters';

import {
  PopularShowsCollection,
  SearchResponse,
  SearchResults,
  ShowCollection,
  VARShow,
  VideoAndWebResultCollection
} from '@/lib/types/search/results'
import { getPromotedResults } from './resultsBuilder';
import Cookies from 'js-cookie';
import { COUNTRY_ID_COOKIE } from '@/lib/constants';
import safeFetch from '@/lib/helpers/safe-fetch';

const SEARCH_RESULTS_PER_PAGE = 10

export interface SearchFiltersObject {
  stationId?: string;
  stationCommonName?: string;
  annualPassportQualifyingAmount?: number;
  page: number;
  query: string;
  rank: SORT_VALUES
  country_id: string,
  start: number;
  limit: number;
  resultType?: RESULT_TYPE_VALUES;
  duration?: DURATION_VALUES;
  passportStatus?: PASSPORT_STATUS_VALUES;
  accessibility?: ACCESSIBILITY_VALUES;
  filterShow?: string;
}

export const DefaultSearchFiltersObject: SearchFiltersObject = {
  page: 1,
  query: '',
  rank: SORT_OPTION.RELEVANCE,
  country_id: Cookies.get(COUNTRY_ID_COOKIE) || 'US',
  start: 0,
  limit: SEARCH_RESULTS_PER_PAGE,
  resultType: RESULT_TYPE_FILTER.ALL,
  duration: DURATION_FILTER.ALL,
  passportStatus: PASSPORT_STATUS_FILTER.ALL,
  accessibility: ACCESSIBILITY_FILTER.ALL,
}

interface SearchConfig {
  abortController?: AbortController
}

async function search(filters: SearchFiltersObject, config: SearchConfig): Promise<SearchResults | null> {
  const searchParams = filtersToParams(filters)

  const url = `/api/v1/search/?${searchParams}`
  const response = await safeFetch(url, { signal: config?.abortController?.signal })
  const json = await response.json() as SearchResponse

  if(!json.meta.filters) return null
  return buildResults(filters, json)
}

function buildResults(filters: SearchFiltersObject, json: SearchResponse) {
  const rawResults = getRawResultsCollections(json)
  const promotedResults = getPromotedResults(filters)
  const resultsCounts = flattenResultsCounts(json)
  const totalResults = Number(json.meta.total_count['videoasset-results'])
  const totalPages = Math.ceil(totalResults / 10)
  const { meta } = json

  return {
    rawResults,
    promotedResults,
    resultsCounts,
    totalResults,
    totalPages,
    meta
  }
}

export function flattenResultsCounts(json: SearchResponse) {
  const filtersResults = json.meta.filters['videoasset-results']
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const collection = filtersResults.find((item: any) => item['show']) as VARShow
  const shows = collection.show

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const counts = filtersResults.reduce((results: any, items: any) => {
    for(const item in items) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      items[item].forEach((a: any) => {
        if(a?.label === 'Audio description') {
          results['descriptive'] = a.count
        } else {
          results[a.value] = a.count
        }
      })
    }

    return results
  }, { shows })

  return counts
}

function getRawResultsCollections(json: SearchResponse) {
  const findCollection = (slug: string) => json.collections.find((result) => result.slug === slug)

  return {
    videoAndWebResults: findCollection('videoasset-results') as VideoAndWebResultCollection | undefined,
    shows: findCollection('show-results') as ShowCollection | undefined,
    popularShows: findCollection('popular-shows') as PopularShowsCollection | undefined
  }
}

export function filtersToParams(filters: SearchFiltersObject) {
  const params = new URLSearchParams()

  if (filters.query) params.set(SEARCH_FIELDS.q, filters.query);
  params.set(SEARCH_FIELDS.page, filters.page.toString())
  params.set(SEARCH_FIELDS.rank, filters.rank);
  params.set(SEARCH_FIELDS.country_id, filters.country_id);
  params.set(SEARCH_FIELDS.start, filters.start.toString());
  params.set(SEARCH_FIELDS.limit, filters.limit.toString());

  if(filters.filterShow && filters?.filterShow !== 'All') {
    params.set('filter_show', filters.filterShow)
  }

  if(filters.resultType && filters?.resultType !== RESULT_TYPE_FILTER.ALL) {
    if(filters.resultType === 'remote_asset') {
      // This means we're filtering to web results which lives in this weird
      // state between video types and item types, and requires the video type
      // to be an empty string.
      params.set(SEARCH_FIELDS.filter_item_type, filters.resultType)
      params.set(SEARCH_FIELDS.filter_video_type, '');

    } else {
      params.set(SEARCH_FIELDS.filter_video_type, filters.resultType);
    }
  }

  if(filters.duration && filters?.duration !== DURATION_FILTER.ALL) {
    params.set(SEARCH_FIELDS.filter_duration, filters.duration);
  }

  if(filters.stationId) {
    params.set(SEARCH_FIELDS.station_id, filters.stationId);
  }

  if(filters.passportStatus && filters?.passportStatus !== PASSPORT_STATUS_FILTER.ALL) {
    params.set(SEARCH_FIELDS.filter_video_availability, filters.passportStatus);
  }

  if(filters.accessibility && filters?.accessibility !== ACCESSIBILITY_FILTER.ALL) {
    params.set(SEARCH_FIELDS.filter_descriptive, filters.accessibility.toString());
  }

  return params
}

export default search
